// Always reads Asia/Jakarta (WIB) time regardless of the device's own timezone — the
// business operates in Indonesia, so a sales rep traveling abroad should still see "Selamat
// Pagi" on Jakarta's morning, not their local one.
function jakartaHour() {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Jakarta", hour: "numeric", hour12: false }).formatToParts(new Date());
  const hourStr = parts.find((p) => p.type === "hour")?.value ?? "0";
  return Number(hourStr) % 24;
}

export function getGreeting(name) {
  const h = jakartaHour();
  const who = name || "";
  if (h >= 4 && h < 11) {
    return { period: "pagi", label: "Selamat Pagi", note: "Semangat mengawali hari ya 🌤️", emoji: "🌤️" };
  }
  if (h >= 11 && h < 15) {
    return { period: "siang", label: "Selamat Siang", note: "Jangan lupa makan siang dan sholat ya! 🍽️🕌", emoji: "☀️" };
  }
  if (h >= 15 && h < 18) {
    return { period: "sore", label: "Selamat Sore", note: "Semangat menutup hari dengan baik ya 🌇", emoji: "🌇" };
  }
  return { period: "malam", label: "Selamat Malam", note: "Jangan lupa istirahat yang cukup ya 🌙", emoji: "🌙" };
}
